var handleBtnTxt = setInterval(SimplBtnTxt, 10);
  
  function SimplBtnTxt(){
    $('.btnsave-txt-jtpl .center-section').hide();
   var elem = $('.btnsave-txt-jtpl').text();
   var simplbtn = $('.cstm-savetxt-jtpl :selected').attr("savetxt");
  $('.btnsave-txt-jtpl .center-section').html(simplbtn);
    console.log("DoneProcess");
  if($('.btnsave-txt-jtpl').html() != ''){
    $('.btnsave-txt-jtpl .center-section').show();
    
    clearInterval(handleBtnTxt);
  }
}
$( document ).ready(function() {
 
$('select.cstm-savetxt-jtpl').on('change', function (e) {
       setTimeout(function() {
      SimplBtnTxt();
      } ,200);
});
});
